import classes from './Navigation.module.css';
import { useEffect, Fragment, useContext, useRef, useState } from 'react';
import { NavLink, useParams } from 'react-router-dom';

// IMPORT DATA
import { globals } from '../../data/global-vars';

// IMPORT OTHER COMPONENTS
import { motion } from 'framer-motion';

// IMPORT OWN COMPONENTS
import Backdrop from '../UI/Backdrop';
import AuthContext from '../../store/auth-context';
import Button from '../UI/Button';

const itemVariants = {
  open: {
    opacity: 1,
    y: 0,
    transition: { type: 'spring', stiffness: 300, damping: 24 },
  },
  closed: { opacity: 0, y: 20, transition: { duration: 0.1 } },
};

function Navigation(props) {
  const authCtx = useContext(AuthContext);
  const params = useParams();

  // set brand if no brand given
  let brand = params.brand;
  let primeColor = props.primeColor;
  if (!brand) {
    primeColor = globals.BRANDS.VW.primeColor;
    brand = globals.BRANDS.VW.url;
  }

  // set show of navigation
  const show = props.show;
  useEffect(() => {
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [show]);

  const contentRef = useRef(null);
  const [wrapperScroll, setWrapperScroll] = useState(false);

  function updateDivHeight() {
    const wrapperHeight = window.innerHeight;
    const contentHeight = contentRef.current.scrollHeight;

    if (show) {
      if (wrapperHeight - 40 < contentHeight) {
        setWrapperScroll(true);
      } else setWrapperScroll(false);
    }
  }

  useEffect(() => {
    updateDivHeight();

    const handleResize = () => {
      updateDivHeight();
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [show]);

  return (
    <Fragment>
      <Backdrop onClick={props.onHide} show={show} />
      <motion.nav
        initial={false}
        animate={show ? 'open' : 'closed'}
        className={`${classes.wrapper} ${show && classes.active} 
        ${wrapperScroll && classes.scroll}
        `}
      >
        <motion.div
          className={classes.navList}
          ref={contentRef}
          variants={{
            open: {
              clipPath: 'inset(0% 0% 0% 0% round 10px)',
              transition: {
                type: 'spring',
                bounce: 0,
                duration: 0.7,
                delayChildren: 0.1,
                staggerChildren: 0.05,
              },
              overflowY: 'scroll',
            },
            closed: {
              clipPath: 'inset(0% 50% 0% 0% round 10px)',
              transition: {
                type: 'spring',
                bounce: 0,
                duration: 0.3,
              },
            },
          }}
          style={{
            pointerEvents: show ? 'auto' : 'none',
            listStyleType: 'none !important',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {Object.values(globals.PAGES).map((item, i) => {
            if (
              (item.loginNeeded !== true || authCtx.isLoggedIn) &&
              (item.role !== 'admin' || authCtx.isAdmin) &&
              (item.role !== 'superadmin' || authCtx.isSuperAdmin) &&
              !item.hideInNav
            ) {
              return (
                <motion.div
                  variants={itemVariants}
                  style={{
                    width: '100%',
                    display: 'flex',
                    cursor: 'pointer',
                  }}
                  key={i}
                >
                  <NavLink
                    to={`/${brand}/${item.url}/`}
                    className={`${classes.navListItem}`}
                    activeClassName={classes.active}
                    activeStyle={{ color: primeColor }}
                    onClick={() => {
                      props.onHide();
                      window.scrollTo(0, 0);
                    }}
                  >
                    {item.name}
                  </NavLink>
                </motion.div>
              );
            } else return null;
          })}
          {authCtx.isLoggedIn && (
            <span
              className={`${classes.navListItem}`}
              onClick={() => {
                props.onHide();
                window.scrollTo(0, 0);
                authCtx.logout();
              }}
            >
              <motion.span
                variants={itemVariants}
                style={{
                  textDecoration: 'none',
                }}
              >
                <Button color="var(--audi-color)" maxWidth="200px">
                  Ausloggen
                </Button>{' '}
              </motion.span>
            </span>
          )}
        </motion.div>
      </motion.nav>
    </Fragment>
  );
}

export default Navigation;
